<template>
  <AppSelect
    label="Country"
    :items="objectKeys(VISA_COUNTRIES).map(country => ({
      title: getVisaCountryName(country),
      value: country
    }))"
  />
</template>

<script setup lang="ts">
import { VISA_COUNTRIES, getVisaCountryName } from '~/helpers/visa-country';
import { objectKeys } from '~/helpers/general';
</script>